import React, { useState } from 'react'
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Logo from '../Components/Images/reccur logo.svg'
import vector3 from '../Components/Images/vector3.png'
import vector4 from '../Components/Images/vector4.png'
import orangeTransfer from '../Components/Images/orangeTransfer.png'
import orangeBank from '../Components/Images/orangeBank.png'
import orangePayments from '../Components/Images/orangePayments.png'
import purpleWorld from '../Components/Images/purpleWorld.png'
import purpleEmail from '../Components/Images/purpleEmail.png'
import purpleGlobal from '../Components/Images/purpleGlobal.png'
import world3 from '../Components/Images/world3.png'
import world2 from '../Components/Images/world2.png'
import chat from '../Components/Images/chat.png'
import airplane from '../Components/Images/airplane.png'
import CryptoIcon from '../Components/Images/CryptoIcon.png'
import hr2 from '../Components/Images/hr2.png'
import hr from '../Components/Images/hr.png'
import { MdMenu } from 'react-icons/md'
import Footer from '../Components/Footer'
import { BiDollar } from 'react-icons/bi'
import HomeNavBar from '../Components/HomeNavBar'
import newLogo from '../Components/Images/newLogo.png'
import bg from '../Components/Images/bg2.png'
import { useLocation } from 'react-router-dom';
import countries from '../Components/Images/countries2.png'
import { RiArrowRightSLine } from 'react-icons/ri';
import FAQ2 from '../Components/FAQ2';

const AboutUs = () => {

    const [openMenu, setOpenMenu] = useState(false)
    const location = useLocation()

    // const sliderRef = useRef(null);

    // const settings = {
    //     dots: false,
    //     infinite: false,
    //     speed: 2000,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    // };

    // const goToSlide = (index) => {
    //     if (sliderRef.current) {
    //         sliderRef.current.slickGoTo(index);
    //     }
    // };

    return (
        <div className='3xl:text-2xl mk:text-lg sd:text-[17px] text-[14px]'>
            <div className='sd:m-10'>
                <div
                    className="relative w-full rounded-[20px] bg-[#E8E1F5]"
                    style={{
                        backgroundImage: `url(${bg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: '#E8E1F5'
                    }}
                >
                    <div className='relative w-full top-0 rounded-[20px] z-50 text-black sd:px-12 px-2 sd:py-12 py-4 pb-16'>
                        <div className='relative'>
                            <div className='flex justify-between items-center px-2'>
                                <a href="/">
                                    <div className='flex gap-2 items-center'>
                                        <img src={Logo} className='mk:w-auto w-5' alt="" />
                                        <p className='font-medium'>reccur</p>
                                    </div>
                                </a>
                                <div className='lg:flex hidden gap-8 ml-24'>
                                    <a href="/use_cases">
                                        <p className={`${location.pathname === '/use_cases' && 'font-bold'}`}>Use cases</p>
                                    </a>
                                    <a href="/how_it_works">
                                        <p className={`${location.pathname === '/how_it_works' && 'font-bold'}`}>How it Works</p>
                                    </a>
                                    <a href="/about">
                                        <p className={`${location.pathname === '/about' && 'font-bold'}`}>About</p>
                                    </a>
                                </div>
                                <div className='lg:flex hidden'>
                                    <a href="/login">
                                        <button className='py-2 px-[14px]'>Log in</button>
                                    </a>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] font-light text-white py-2 px-[14px] rounded-[10px]'>
                                            Get started
                                        </button>
                                    </a>
                                </div>
                                <MdMenu onClick={() => setOpenMenu(!openMenu)} className='lg:hidden cursor-pointer sh:text-[30px] text-xl' />
                            </div>

                            <div className='flex lg:flex-row flex-col justify-between gap-6 w-full mt-20 lg:items-start items-center'>
                                <div className='w-full flex flex-col items-center gap-6'>
                                    <img className='sd:size-32 size-24' src={newLogo} alt="" />
                                    <p className='font-semibold 3xl:text-5xl text-center text-4xl'>Rewriting the rules of <br className='sk:block hidden' /> global finance</p>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] text-white flex gap-2 items-center justify-center sh:py-[14px] py-[9px] px-[24px] shadow-md shadow-[#531CB3] rounded-lg'>
                                            Get started
                                            <RiArrowRightSLine className='size-7' />
                                        </button>
                                    </a>
                                    <div className='flex items-center gap-0'>
                                        <img className='3xl:w-36 sd:w-28 w-[70px]' src={countries} alt="" />
                                        <p className='text-[#525154] font-normal'>Open a bank account in 30+ countries.</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <HomeNavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </div>
                </div>
            </div>
            <div className='sh:py-[120px] py-10 sh:px-10 px-5 flex flex-col gap-12'>
                <div className='mk:grid grid-cols-2 flex flex-col sh:px-10 mk:gap-20 gap-4'>
                    <div className='font-semibold w-full'>
                        <p className='uppercase text-[#431594]'>What We're Building</p>
                        <p className='mk:text-[46px] sd:text-[36px] text-[26px] mk:mt-6 mt-3 mk:font-semibold sd:leading-none leading-tight font-normal'>Think of us as the bridges between traditional finance and the future</p>
                    </div>
                    <p className='text-[#525154] w-full font-normal'>
                        We’re creating something big, an easy way to move, manage, and make money work for you, no matter
                        where you are or how you earn. Think of it like having your own financial toolbox, but without the
                        complicated stuff. Just simple, fast, and secure payments across currencies, borders, and platforms.
                        We’re building this for people who need their money to move with them, whether they’re working remotely,
                        sending crypto, or just living globally. Let’s make money simpler, together.
                    </p>
                </div>
                <div className='text-[#ffffff] mt-4 font-normal flex mk:flex-row flex-col justify-center sh:px-10'>
                    <div className='bg-[#531CB3] h-[235px] p-10 flex flex-col justify-between gap-4'>
                        <p className='mk:text-3xl text-xl'>Our mission</p>
                        <p className='text-[#D2D0D6]'>
                            Remember when making an international call was a whole thing? Now you video chat with someone across the world
                            without thinking twice. That's what we're doing for money.
                        </p>
                    </div>
                    <div className='bg-[#271D2E] p-10 h-[260px] flex flex-col justify-between gap-4'>
                        <p className='mk:text-3xl text-xl'>Our vision</p>
                        <p className='text-[#D2D0D6]'>
                            Remember when making an international call was a whole thing? Now you video chat with someone across the world
                            without thinking twice. That's what we're doing for money.
                        </p>
                    </div>
                </div>
            </div>
            {/* <Slider {...settings} ref={sliderRef}> */}
            <div>
                <div className='py-[120px] sh:px-10 px-5 bg-[#FEEDED] flex flex-col gap-16'>
                    <div className='flex justify-between sh:px-6 items-start'>
                        <div>
                            <p className='text-[#DC2626] cursor-pointer font-semibold pb-4 uppercase'>The Problem</p>
                            <p className='mk:text-[50px] text-[30px] mk:leading-none leading-tight'>Money is still living <br className='mk:block hidden' /> <span className='text-[#DC2626] font-semibold'>in the past</span></p>
                        </div>
                    </div>
                    <div className='flex mk:flex-row flex-col gap-5 sh:px-6 items-center justify-'>
                        <div className='w-full'>
                            <img className='w-full' src={vector3} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={orangeBank} alt="" />
                                <p className='text-[24px] text-[#302F33] pt-8'>Banks are stuck</p>
                                <p className='text-[16px] text-[#525154]'>Banks stuck in their own countries</p>
                            </div>
                        </div>
                        <div className='w-full'>
                            <img className='w-full' src={vector3} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={orangeTransfer} alt="" />
                                <p className='text-[22px] lg:text-[24px] text-[#302F33] pt-8'>Expensive transfers</p>
                                <p className='text-[16px] text-[#525154]'>Expensive international transfers</p>
                            </div>
                        </div>
                        <div className='w-full'>
                            <img className='w-full' src={vector3} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={orangePayments} alt="" />
                                <p className='text-[24px] text-[#302F33] pt-8'>Payment delays</p>
                                <p className='text-[16px] text-[#525154]'>Days of waiting for payments</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className='py-[120px] sh:px-10 px-5 bg-[#E8E1F5] flex flex-col gap-16'>
                    <div className='flex justify-between sh:px-6 items-start'>
                        <div>
                            <p className='text-[#431594] cursor-pointer font-semibold pb-4 uppercase'>The solution</p>
                            <p className='mk:text-[50px] text-[30px] mk:leading-none leading-tight'>We're making finance work <br className='mk:block hidden' /> <span className='text-[#431594] font-semibold'>in the past</span></p>
                        </div>
                    </div>
                    <div className='flex mk:flex-row flex-col gap-5 sh:px-6 items-center justify-'>
                        <div className='w-full'>
                            <img className='w-full' src={vector4} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={purpleEmail} alt="" />
                                <p className='text-[24px] text-[#302F33] pt-8'>Fast as an email</p>
                                <p className='text-[16px] text-[#525154]'>Instant, like sending an email</p>
                            </div>
                        </div>
                        <div className='w-full'>
                            <img className='w-full' src={vector4} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={purpleWorld} alt="" />
                                <p className='text-[24px] text-[#302F33] pt-8'>No boundaries</p>
                                <p className='text-[16px] text-[#525154]'>Borderless, like browsing the web</p>
                            </div>
                        </div>
                        <div className='w-full'>
                            <img className='w-full' src={vector4} alt="" />
                            <div className='font-normal bg-[#F9F7FCCC] pt-[50px] pb-10 px-10'>
                                <img src={purpleGlobal} alt="" />
                                <p className='text-[24px] text-[#302F33] pt-8'>Payment delays</p>
                                <p className='text-[16px] text-[#525154]'>Days of waiting for payments</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </Slider> */}
            <div className='py-24 sh:px-10 px-5 bg-[#271D2E] text-[#F3F0F7]'>
                <div className='flex mk:flex-row flex-col justify-between mk:gap-28 gap-10 sh:px-10'>
                    <div className='mk:w-[560px]'>
                        <p className='text-[#E8E1F5] text-xs font-semibold'>OUR WHY</p>
                        <p className='text-[#FFFFFF] mh:text-[36px] text-2xl font-semibold mt-4'>Just like how</p>
                        <p className='text-[#F3F0F7] mh:text-[18px] mt-4 font-normal'>We believe we will do the same for money. No more financial borders. No more waiting. No more "sorry, we don't support your country."</p>
                    </div>
                    <div className='flex flex-col gap-14 relative mk:w-[584px]'>
                        <img src={hr} className='absolute sa:top-[18%] top-[16%] left-5' alt="" />
                        <img src={hr} className='absolute sa:top-[60%] sk:top-[58%] top-[54%] left-5' alt="" />
                        <div className='flex items-center gap-4'>
                            <img src={airplane} alt="" />
                            <p className='mh:text-[18px] font-medium'>Airplanes made physical borders feel smaller</p>
                        </div>
                        <div className='flex items-center gap-4'>
                            <img src={world3} alt="" />
                            <p className='mh:text-[18px] font-medium'>The internet made information borderless</p>
                        </div>
                        <div className='flex items-center gap-4'>
                            <img src={chat} alt="" />
                            <p className='mh:text-[18px] font-medium'>Social media connected global communities</p>
                        </div>
                    </div>
                </div>
                <hr className='my-20 border border-[#7b7a7e]' />
                <div className=''>
                    <div className='mk:w-[700px] flex flex-col gap-4 sh:px-10'>
                        <p className='text-[#E8E1F5] font-semibold'>JOIN US</p>
                        <p className='text-[#ffffff] mh:text-[36px] text-2xl font-semibold leading-tight'>You're joining a movement towards truly borderless finance.</p>
                        <p className='text-[#F3F0F7] mh:text-[18px] font-normal'>If you’re looking to make global finance easy, Reccur’s got you covered. No more hassle, just simple, seamless money management.</p>
                    </div>
                    <div className='flex flex-wrap relative sh:pl-10 mp:justify-between gap-5 mt-20'>
                        <div className='flex flex-col gap-4 mp:w-[360px] sh:w-[48%]'>
                            <BiDollar className='size-7' />
                            <p className='mh:text-[20px] text-[18px] font-normal'>Freelancers</p>
                            <p className='mh:text-[17px] font-normal text-[#F3F0F7]'>A freelancer tired of payment hassles</p>
                        </div>
                        <img src={hr2} className='absolute xl:block hidden top-[40%] w-[330px] 3xl:w-[700px] left-[15%] 3xl:left-[10%] -translate-x-[10%] -translate-y-[40%]' alt="" />
                        <img src={hr2} className='absolute xl:block hidden top-[40%] left-1/2 w-[350px] 3xl:w-[700px] -translate-y-[40%]' alt="" />
                        <div className='flex flex-col items-start gap-4 mp:w-[360px] sh:w-[48%]'>
                            <img src={CryptoIcon} className='w-[30px]' alt="" />
                            <p className='mh:text-[20px] text-[18px] font-normal'>Crypto fam</p>
                            <p className='mh:text-[17px] font-normal text-[#F3F0F7]'>A crypto enthusiast who gets the vision</p>
                        </div>
                        <div className='flex flex-col items-start gap-4 mp:w-[360px] sh:w-[48%]'>
                            <img src={world2} className='size-[30px]' alt="" />
                            <p className='mh:text-[20px] text-[18px] font-normal'>Global hustlers</p>
                            <p className='mh:text-[17px] font-normal text-[#F3F0F7]'>Someone who just wants easier access to global finance</p>
                        </div>
                    </div>
                </div>
            </div>
            <FAQ2 />
            <Footer />
        </div>
    )
}

export default AboutUs